import GlobalStyle from "./globalStyle";
import Navbar from "./component/Navbar";
import Hero from "./component/Hero";
import React, {useState} from 'react'
import { SliderData } from './data/SliderData';
import Dropdown from './component/Dropdown';
import InfoSection from "./component/infoSection";
import { InfoData, InfoDataTwo } from './data/InfoData';






function App() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <GlobalStyle />
      <Navbar toggle={toggle} />
      <Dropdown isOpen={isOpen} toggle={toggle} />
      <Hero slides={SliderData} />
      <InfoSection {...InfoData} />
      <InfoSection {...InfoDataTwo} />


    </>
  );
}

export default App;
